<template>
    <div>
       <v-card color="grey lighten-4">
            <v-snackbar :timeout="timeout" :color="color" :left="left" v-model="snackbar">{{ message }}</v-snackbar>
        </v-card>
     <v-container>
     		<!-- Form -->
		<v-card>
			<v-card-title>
				<span class="headline">{{ formTitle }}</span>
			</v-card-title>
			<v-form v-model="valid" ref="form" lazy-validation>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							
							<v-flex xs12 sm4 md4>								
								 <v-text-field label="Category Name" v-model="formSchema.category_name" :rules="[v => !!v || 'Field is required']" required></v-text-field>
							</v-flex>

                            <v-flex xs12 sm4 md4>
                                <v-select
                                :items="areaList"
                                label="Area"
                                item-value="text"
                                
                                v-model="formSchema.area"
                                :rules="areaRules"
                                ></v-select>
                            </v-flex>
							<v-flex xs12 sm4 md4>							
								 <v-text-field label="Gross" v-model="formSchema.gross" :rules="grossRules" required></v-text-field>
								   
							</v-flex>	
               <v-flex xs12 sm6 md4>	
							 </v-flex>
                <v-flex xs12 sm6 md4>	
							 </v-flex>
               <v-flex xs12 sm6 md4>	
								     <v-checkbox v-model="formSchema.active" label="Active" :value="isActiveVal"></v-checkbox>
									</v-flex>					
						</v-layout>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="success" @click.native="validateBeforeSubmit">{{buttonTitle}}</v-btn>
					<v-btn color="error" @click.native="reset">Reset</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
		<!-- /Form -->  
     </v-container>
      
    </div>
</template>
<script>
/**
 * ---------------------
 *  implements by majeed
 * ---------------------
 */
const commonService = require('../../../services/common.service');

import {preFix} from '../../../vuex/api'
import Axios from 'axios'
export default {
    props:['formSchema'],
    data: () => ({
      isActiveVal: 0, 
      valid: true,
      dialog: false,
      dialogEditForm:false,

      search: '',
      totalItems: 0,      
      loading: true,

      pagination: {
        sortBy: 'id',
        descending:true,
      },
      
      selected:[],
      search:'',      
      headers: [
      {
        text: 'Name',
        align: 'left',
        sortable: false,
        value: 'name'
      },
      { text: 'User Type', align: 'left', value: 'type_id' },
      { text: 'Email', value: 'email' },
      
      ],

      areaList:[
          {id:1, text:'Dhaka Metro'},
          {id:2, text:'Chattogram'},
          {id:3, text:'Khulna'},
          {id:4, text:'Syhlet'},
          {id:5, text:'Barisal'},
          {id:6, text:'Rajshahi'},
          {id:7, text:'Rangpur'},
          {id:8, text:'Narayanganj'},
          {id:9, text:'Gazipur'},
          {id:10, text:'Savar Poroushova'},
          {id:11, text:'Others Area'},

      ],
      
      delete_id:'',
      row_index:'',
      dialog2: false,
      snackbar: false,
      color: 'success',
      mode: '',
      timeout: 3000,
      left:'left',
      message: '',

      select: null,
      instituteList: [],

      typelist:[],

      grossRules: [
        v => !!v || "Gross is required",
        v => /^[1-9]\d*(\.\d+)?$/.test(v) || "Gross must be valid"
      ],
      areaRules: [
          v => !!v || 'Area is required',
        ],
      instituteShow:true,
    }),

    computed: {
      formTitle () {
        return this.formSchema.id > 0 ? 'Update Category of Outsourcing Staff' : 'Add Category of Outsourcing Staff'
      },
      buttonTitle () {
        return this.formSchema.id > 0 ? 'Update' : 'Save'
      },
    },

    created () {
     
    },
   
    methods: {
       changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },

      validateBeforeSubmit(e) {

        var formSchema = this.formSchema
        var root = this

        if (this.$refs.form.validate()) {

          if ( formSchema.id > 0 )
          {            
              commonService.updateFormData(this.formSchema, 'salary_category').then(res => {							
							
              let actionData = {
							message: res.message,
							data: res.data,
							action: "edit",
							status: res.status
							};
							this.close(actionData);
						});
            
          }
          else
          {            
            commonService.insertFormData(this.formSchema, 'salary_category').then(res => {							
							let actionData = {
							message: res.message,
							data: res.data,
							action: "add",
							status: res.status
							};
							this.close(actionData);
						});
            
          }
        }  

      },

      close:function(message){
				 if(message.status == 1)
      		{
            this.$refs.form.reset();
				 }				
				this.$emit('reloadData', message)
			},
   reset() {
      if (this.formSchema.id > 0) {
        close(0);
      } else {
        this.$refs.form.reset();
      }
    },
    },

    watch:{
      // props re-activity 
      item (){
         this.formSchema = this.item
         console.log(this.formSchema)
      }
    },

    mounted () {
      
    },
}
</script>


// WEBPACK FOOTER //
// src/components/administration/salary_category_entry/salary_category_form.vue